import { BundleMetaChangeHistoryInterface } from "../interfaces/BundleMetaChangeHistory/BundleMetaChangeHistory";
import { CreateBundleMetaChangeHistoryInterface } from "../interfaces/BundleMetaChangeHistory/CreateBundleMetaChangeHistory";
import BaseService from "./BaseService";

export class BundleMetaChangeHistoryService extends BaseService<BundleMetaChangeHistoryInterface, CreateBundleMetaChangeHistoryInterface>{ 
    constructor(){
        let url: string = '/bundle-meta/admin'
        super(url)
    }
}